var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106 106",
    enableBackground: "new 0 0 106 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 25") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    filterUnits: "userSpaceOnUse",
    x: 27,
    y: 27,
    width: 57.2,
    height: 52.6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 27,
    width: 57.2,
    height: 52.6,
    id: "b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    filter: "url(#a)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2 0H40c6.2 0 11.2 5 11.2 11.2V40c0 6.2-5 11.2-11.2 11.2H11.2C5 51.2 0 46.2 0 40V11.2C0 5 5 0 11.2 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c",
    filterUnits: "userSpaceOnUse",
    x: 13.4,
    y: 12.8,
    width: 43.8,
    height: 39.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 13.4,
    y: 12.8,
    width: 43.8,
    height: 39.8,
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2 0H40c6.2 0 11.2 5 11.2 11.2V40c0 6.2-5 11.2-11.2 11.2H11.2C5 51.2 0 46.2 0 40V11.2C0 5 5 0 11.2 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    filter: "url(#c)"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#d)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f7f7f7",
    d: "M13.4 27.3l26.3 25.3 15.4-.6 2.1-9.2-31-30-.6 12.8z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "e",
    filterUnits: "userSpaceOnUse",
    x: 12.8,
    y: 12.8,
    width: 25.6,
    height: 25.6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 12.8,
    y: 12.8,
    width: 25.6,
    height: 25.6,
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2 0H40c6.2 0 11.2 5 11.2 11.2V40c0 6.2-5 11.2-11.2 11.2H11.2C5 51.2 0 46.2 0 40V11.2C0 5 5 0 11.2 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    filter: "url(#e)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 12.8c1.3 0 2.4 1.1 2.4 2.4v8h8c1.3 0 2.4 1.1 2.4 2.4S37.3 28 36 28h-8v8c0 1.3-1.1 2.4-2.4 2.4s-2.4-1.1-2.4-2.4v-8h-8c-1.3 0-2.4-1.1-2.4-2.4s1.1-2.4 2.4-2.4h8v-8c0-1.3 1.1-2.4 2.4-2.4z",
    mask: "url(#f)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#eaeaea"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.f9c90a2464e6e39277b387519d36214c.svg";
export { ForwardRef as ReactComponent };